import React from 'react';
import {
  Button,
} from '@mui/material';
import PrepayOptions from './prepayOptions';
import MortgageRefinance from './mortgageRefinance';
import type { PrepayDialogProps } from '../../../types/account';
import AlertDialog from '../../../components/AlertDialog';

export default function PrepayDialog(props: PrepayDialogProps) {
  const {
    unpaidAmount, paidAmount, token, loanState, productType, loanId, periods,
    refinancePolicy,
    currency,
  } = props;

  if (productType === 'bnpl') {
    return null;
  }

  const isMortgage = productType === 'mortgage';

  return (
    <AlertDialog
      maxWidth="xs"
      hideSubmitButton
      button={(
        <Button
          variant="outlined"
          color="primary"
        >
          Solicitar Refinanciamiento
        </Button>
      )}
      dialogContent={isMortgage ? (
        <MortgageRefinance />
      ) : (
        <PrepayOptions
          unpaidAmount={unpaidAmount}
          paidAmount={paidAmount}
          loanState={loanState}
          productType={productType}
          token={token}
          loanId={loanId}
          periods={periods}
          refinancePolicy={refinancePolicy}
          currency={currency}
        />
      )}
    />

  );
}
